import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import { WHAT_WE_DO } from "../../data/site";

export default function About() {
  return (
    <MarketingLayout>
      <Seo title="About — AllToMAIDIt Solutions" description="AllToMAIDIt is a scalable creative technology and business solutions company." />
      <div className="marketing-grid-bg border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
          <p className="eyebrow text-alto-red mb-4">About AllToMAIDIt</p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-tight">We build the systems that help organizations run and grow.</h1>
          <p className="text-neutral-300 mt-6 max-w-3xl text-sm sm:text-lg leading-relaxed">
            AllToMAIDIt Solutions combines creative technology, digital solutions, AI, automation, IT and strategic systems to help organizations operate more efficiently, reach people and grow. We start with a strong product — AllToMAIDIt CRM — and expand into the products, services and integrations each customer actually needs.
          </p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHAT_WE_DO.map((w) => (
            <div key={w.title} className="card-hairline rounded-xl p-6 bg-alto-charcoal">
              <w.icon className="text-alto-red mb-4" size={26} />
              <h3 className="font-display text-lg font-bold mb-2">{w.title}</h3>
              <p className="text-sm text-neutral-400">{w.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 rounded-2xl p-8 bg-alto-panel border border-white/10">
          <h2 className="font-display text-2xl font-bold mb-3">Our approach</h2>
          <p className="text-neutral-300 text-sm leading-relaxed max-w-3xl">The customer's problem determines the solution — whether that's a single product, a single service, a combination, or a complete custom build. We design for scale from day one so what we build today never limits what you become tomorrow.</p>
          <Link to="/contact" className="btn-red font-bold px-6 py-3.5 rounded-md inline-flex items-center gap-2 mt-7 text-sm">LET'S BUILD YOUR SOLUTION <ArrowRight size={16} /></Link>
        </div>
      </div>
    </MarketingLayout>
  );
}
